import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

// ActionCreators

import { notificationsActionCreators } from '@actions/individualPortal/secureInbox/secureInboxActionCreators';

// Hooks

import { useInboxId } from '@hooks/useInboxId';

/**
 * 
 * This is a temporary hardcoded version of the SecureInbox
 * sidenav that will be seen by anyone viewing their
 * own inbox. The Back to Dashboard link switches between a
 * normal anchor tag and React Router Link (see SecureInbox.js)
 * based on impersonation status and role of logged in user.
 * 
 * This sidenav might be kept and updated in the future, in
 * which case we can create separate configs. Alternatively,
 * this sidenav might be discarded altogether as other roles'
 * dashboards are refactored to React. In that case, exisiting
 * sidenav configs could be expanded to handle different roles.
 *  
 * - Owen H, 5 Aug 2020
 * 
 */


const NonIndSideNav = props => {

    const {
        actions: {
            fetchNotifications
        },
        environment: {
            impersonation = false,
            impersonationDetails,
            user: {
                activeModuleId: householdId = 0,
                userId,
                role
            },
            reduxUnreadMessageCount = 0
        },
        setEmailShown,
        query,
        setQuery
    } = props;

    const inboxIdData = {
        ...{
            householdId,
            impersonation,
            impersonationDetails,
            role,
            userId
        }
    };

    const { part, inboxId } = useInboxId(inboxIdData);
    
    const handleInboxSearch = e => {
        e.preventDefault();

        if (query !== '') {
            setEmailShown(null);
            fetchNotifications(part, inboxId, 0, query);
        }
    };

    const onInboxReset = e => {
        e.preventDefault();

        setEmailShown(null);

        setQuery('');
        fetchNotifications(part, inboxId, 0);
    };

    const handleChangeQuery = e => {
        setQuery(e.target.value);
    };

    useEffect(() => {
        return () => {
            setQuery('');
        };
    }, []);


    return (
        <Fragment>
            <nav aria-label="Secondary navigation" className='margin-t-20'>
                <div className="usa-sidenav gi-sidenav">
                    <Fragment>
                        <div className="header">
                            <h3 className="heading">
                                <FormattedMessage id='common.search'/>
                            </h3>
                        </div>
                        <ul className="usa-list usa-list--unstyled gi-sidenav__list">
                            <Fragment>
                                <li className="usa-sidenav__item padding-0">
                                    <form className="usa-form gi-forms">
                                        <div className="grid-row gi-component margin-y-105 flex-no-wrap">
                                            <input
                                                className="grid-col-10 gi-regular_input__input"
                                                type="text"
                                                aria-label='Search'
                                                value={query}
                                                onChange={handleChangeQuery}
                                            />
                                            <button
                                                className="grid-col-2 gi-button gi-button__primary gi-button__input-field-right sidebar-search_button"
                                                aria-label="Click to search"
                                                onClick={handleInboxSearch}
                                            >
                                                <FontAwesomeIcon icon='search' className="grid-col-1" />
                                            </button>
                                        </div>
                                    </form>
                                </li>
                            </Fragment>
                        </ul>
                    </Fragment>
                    <Fragment>
                        <div className="header">
                            <h3 className="heading">
                                <FormattedMessage id='common.folder'/>
                            </h3>
                        </div>
                        <ul className="usa-list usa-list--unstyled gi-sidenav__list">
                            <Fragment>
                                <li className="usa-sidenav__item">
                                    <div className="grid-row flex-no-wrap">
                                        <a href='#'>
                                            <div className={'grid-col-auto'} onClick={onInboxReset}>
                                                <FormattedMessage id='common.inbox'/>
                                                <span className={`unreadRecords-nonInd ${!reduxUnreadMessageCount ? 'hide' : ''}`}>{reduxUnreadMessageCount}</span>
                                            </div>
                                        </a>
                                    </div>
                                </li>
                            </Fragment>
                        </ul>
                    </Fragment>
                </div>
            </nav>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(notificationsActionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(NonIndSideNav);
